import * as React from "react";
import { Box, Button } from "@talentpair/quantic";

export function CallToActionCard(): React.ReactElement | null {
  return (
    <Box variant="column" layout="start-start" space={3}>
      <Button variant="contained" color="primary" href="https://get.talentpair.com/supercharge">
        Book a demo
      </Button>
    </Box>
  );
}
